<template>
  <div>
    <el-form-item label="不投放对象：">
      <div>
        <el-button type="primary" size="small" plain @click="openDocAll">选择用户</el-button>

        <el-button type="success" plain size="small" style="margin: 10px 0; position: relative">
          选择文件
          <input
            class="uploadBtn"
            type="file"
            accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            @change="sendfile($event)"
          />
        </el-button>

        <el-link type="primary" :underline="false" href="https://wap.ibabygroup.cn/ph/document/sendCoupon.xls"
          >（下载模板）</el-link
        >
      </div>
      <el-card class="col" style="position: relative; width: 400px" v-show="total">
        <el-link type="danger" :underline="false" class="clear" @click="clear">清空</el-link>
        <p>已选择 {{ total }} 位用户</p>
      </el-card>
    </el-form-item>
    <doc-all-select ref="alldoc" :isSingle="false" @select-submit="choiceAllDocCallback"></doc-all-select>
  </div>
</template>

<script scoped>
import XLSX from 'xlsx'
import { commonUrl } from '@/api/common'
import docAllSelect from '@/components/selectSource/selectDoctor'
export default {
  components: {
    docAllSelect
  },
  data() {
    return {
      commonUrl: commonUrl,
      actvieType: '', // 当前选择的类型 user-用户，file-文件
      list: []
    }
  },
  computed: {
    total() {
      return this.list.length
    }
  },
  methods: {
    setInit(list) {
      this.list = list || []
    },
    // 打开医生列表
    openDocAll() {
      this.$refs.alldoc.open('选择医生')
    },
    choiceAllDocCallback(data) {
      if (this.actvieType !== 'user') {
        this.actvieType = 'user'
        this.list = []
      }
      const phones = data.map((item) => item.phone)
      this.list = this.list.concat(phones)
      console.log(this.list, data)
    },

    // 上传文件
    sendfile(obj) {
      obj = obj.currentTarget
      var zzexcel
      var res = ''
      if (!obj || !obj.files || !obj.files.length) {
        return
      }
      var f = obj.files[0]
      var reader = new FileReader()
      reader.readAsBinaryString(f)
      this.pushExcelName = f.name
      this.$message.warning('正在上传，请稍后...')
      reader.onload = (e) => {
        var data = e.target.result
        zzexcel = XLSX.read(data, {
          type: 'binary'
        })
        res = XLSX.utils.sheet_to_json(zzexcel.Sheets[zzexcel.SheetNames[0]])
        // 对象数组转数组
        let arr = []
        for (let i = 0; i < res.length; i++) {
          arr[i] = res[i]['手机号(从第二行开始)']
        }
        this.actvieType = 'file'
        this.list = arr
        this.$message.success('上传成功')
      }
    },
    getString() {
      return this.list.join(',')
    },
    getArray() {
      return this.list || []
    },
    clear() {
      this.list = []
    }
  }
}
</script>

<style type="text/less" lang="less" scoped>
.uploadBtn {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.clear {
  position: absolute;
  right: 10px;
  top: 0;
  font-size: 12px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/operateManage/adsListNew/components/noPushList.vue